var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 11,
    viewBox: "1016 6933 39 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1021.5 6933h28a5.5 5.5 0 0 1 5.5 5.5 5.5 5.5 0 0 1-5.5 5.5h-28a5.5 5.5 0 0 1-5.5-5.5 5.5 5.5 0 0 1 5.5-5.5z",
    fill: "#0abead",
    fillRule: "evenodd",
    "data-name": "line"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.ab747214c86e8b87f08f8d1c1c5774be.svg";
export { ForwardRef as ReactComponent };